/**
 * Created by ianandersen on 4/5/17.
 */

import React from 'react';
import Linkify from 'react-linkify';

class Description extends React.Component {
  constructor(props) {
    super(props);
    this.text = props.text;
  }

  render() {
    if (/<[a-z][\s\S]*>/i.test(this.text)) {
      return <div className="file-description">
        <Linkify>
          <div style={{textAlign: 'left'}} dangerouslySetInnerHTML={{__html: this.text}}></div>
        </Linkify>
      </div>;
    }
    const text = this.text ? this.text.replace(/(?:\r\n|\r|\n)/g, "<br />") : null;
    return <div className="file-description">
      <Linkify><p className="lead" dangerouslySetInnerHTML={{__html: text}}></p></Linkify>
    </div>;
  }
}

export default Description;
